import { render, staticRenderFns } from "./hqStuPositionEdit.vue?vue&type=template&id=62e5487e&scoped=true"
import script from "./hqStuPositionEdit.vue?vue&type=script&lang=js"
export * from "./hqStuPositionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e5487e",
  null
  
)

export default component.exports